import { AI_UPDATE_STATE, AI_SET_MESSAGES, AI_SET_CONVERSATION_ID, AI_CLEAR_CONVERSATION } from '.';

export const setAIChatState = state => ({
  type: AI_UPDATE_STATE,
  payload: {
    isChatOpen: state,
  },
});

export const setAIMessages = messages => ({
  type: AI_SET_MESSAGES,
  payload: { messages },
});

export const setAIConversationId = conversationId => ({
  type: AI_SET_CONVERSATION_ID,
  payload: { conversationId },
});

export const clearAIConversation = () => ({
  type: AI_CLEAR_CONVERSATION,
});
